// extracted by mini-css-extract-plugin
export default {"wrapper":"resellerAdmin_wrapper__BFhHS"};